import { Operator } from '.';

export enum POSOperatorMessageEvent {
  POS_OPERATOR_CREATED = 'pos_operator_created',
  POS_OPERATOR_UPDATED = 'pos_operator_updated',
  POS_OPERATOR_DELETED = 'pos_operator_deleted'
}

export interface OperatorDeleted {
  event: POSOperatorMessageEvent.POS_OPERATOR_DELETED;
  data: {
    pos_operator_id: number;
  };
}

export interface OperatorCreated {
  event: POSOperatorMessageEvent.POS_OPERATOR_CREATED;
  data: Operator;
}

export interface OperatorUpdated {
  event: POSOperatorMessageEvent.POS_OPERATOR_UPDATED;
  data: Operator;
}

export type POSOperatorMessage =
  | OperatorCreated
  | OperatorUpdated
  | OperatorDeleted;
